export default __webpack_public_path__ + "3a70362c6a43122723e31775101333ba.svg";